/**
 * 添加账号页（14.34b-2；路由 add-account，入口=账号管理页「添加账号」行）。
 * 登录卡片复用（LoginPage addAccount 模式）：Worker 的 auth/login 在已登录态
 * 自动先收尾旧账号（logout→停 session→清旧库，app.ts retireCurrentAccount），
 * 主线程成功收尾走切换同一条链（settleAccountSwitch：清栈+auth 两相过渡+回首页）。
 * LoginPage 已在主包（登录首屏必需），这里不做懒 chunk。
 */
import { LoginPage } from './LoginPage';
import { appRouter } from '~/nav/appRouter';
import { globalStore } from '~/store/global';
import { settleAccountSwitch } from '~/store/accountsActions';

export function AddAccountPage() {
  return (
    <LoginPage
      addAccount={{
        onBack: () => appRouter().back(),
        commit: (user) => settleAccountSwitch(globalStore(), appRouter(), user),
      }}
    />
  );
}
